export const GENERATE_SUBMIT_NODE_BEGIN = 'GENERATE_SUBMIT_NODE_BEGIN';
export const GENERATE_SUBMIT_NODE_SUCCESS = 'GENERATE_SUBMIT_NODE_SUCCESS';
export const GENERATE_SUBMIT_NODE_FAILURE = 'GENERATE_SUBMIT_NODE_FAILURE';
export const GENERATE_SUBMIT_NODE_DISMISS_ERROR = 'GENERATE_SUBMIT_NODE_DISMISS_ERROR';
export const GENERATE_SUBMIT_FRONT_BEGIN = 'GENERATE_SUBMIT_FRONT_BEGIN';
export const GENERATE_SUBMIT_FRONT_SUCCESS = 'GENERATE_SUBMIT_FRONT_SUCCESS';
export const GENERATE_SUBMIT_FRONT_FAILURE = 'GENERATE_SUBMIT_FRONT_FAILURE';
export const GENERATE_SUBMIT_FRONT_DISMISS_ERROR = 'GENERATE_SUBMIT_FRONT_DISMISS_ERROR';
export const GENERATE_GET_MYSQLTABLE_LIST_BEGIN = 'GENERATE_GET_MYSQLTABLE_LIST_BEGIN';
export const GENERATE_GET_MYSQLTABLE_LIST_SUCCESS = 'GENERATE_GET_MYSQLTABLE_LIST_SUCCESS';
export const GENERATE_GET_MYSQLTABLE_LIST_FAILURE = 'GENERATE_GET_MYSQLTABLE_LIST_FAILURE';
export const GENERATE_GET_MYSQLTABLE_LIST_DISMISS_ERROR = 'GENERATE_GET_MYSQLTABLE_LIST_DISMISS_ERROR';
export const GENERATE_SUBMIT_MYSQLTABLE_BEGIN = 'GENERATE_SUBMIT_MYSQLTABLE_BEGIN';
export const GENERATE_SUBMIT_MYSQLTABLE_SUCCESS = 'GENERATE_SUBMIT_MYSQLTABLE_SUCCESS';
export const GENERATE_SUBMIT_MYSQLTABLE_FAILURE = 'GENERATE_SUBMIT_MYSQLTABLE_FAILURE';
export const GENERATE_SUBMIT_MYSQLTABLE_DISMISS_ERROR = 'GENERATE_SUBMIT_MYSQLTABLE_DISMISS_ERROR';
export const GENERATE_DELETE_MYSQLTABLE_BEGIN = 'GENERATE_DELETE_MYSQLTABLE_BEGIN';
export const GENERATE_DELETE_MYSQLTABLE_SUCCESS = 'GENERATE_DELETE_MYSQLTABLE_SUCCESS';
export const GENERATE_DELETE_MYSQLTABLE_FAILURE = 'GENERATE_DELETE_MYSQLTABLE_FAILURE';
export const GENERATE_DELETE_MYSQLTABLE_DISMISS_ERROR = 'GENERATE_DELETE_MYSQLTABLE_DISMISS_ERROR';
export const GENERATE_MYSQLTABLE_MODAL_CHANGE = 'GENERATE_MYSQLTABLE_MODAL_CHANGE';
export const GENERATE_CHOOSE_CURRENT_MYSQLTABLE = 'GENERATE_CHOOSE_CURRENT_MYSQLTABLE';



// WEBPACK FOOTER //
// ./src/features/generate/redux/constants.js